<template>
  <svg
    :width="size"
    :height="size"
    viewBox="0 0 149 114"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      fill-rule="evenodd"
      clip-rule="evenodd"
      d="M13.1485 13.3997C11.769 14.6846 11 16.4519 11 18.5V35.5H135C136.381 35.5 137.5 34.3807 137.5 33V18C137.5 15.1099 136.289 13.6323 134.728 12.6361C132.875 11.4534 130.468 11 129 11H20.5C16.8655 11 14.5267 12.1162 13.1485 13.3997ZM11 46.5H135C142.456 46.5 148.5 40.4558 148.5 33V18C148.5 10.8901 144.961 6.11764 140.647 3.3639C136.625 0.796604 132.032 -6.67568e-06 129 0H20.5C14.5345 0 9.37331 1.88384 5.65147 5.35027C1.93098 8.81543 0 13.5481 0 18.5V93.5C0 100.909 2.64754 106.309 6.81384 109.744C10.7727 113.008 15.4978 114 19 114H130C136.528 114 141.309 111.151 144.341 107.252C147.211 103.562 148.382 99.1393 148.497 95.6832L148.5 95.5916V69C148.5 65.9624 146.038 63.5 143 63.5C139.962 63.5 137.5 65.9624 137.5 69V95.3952C137.432 96.9305 136.852 98.9642 135.659 100.498C134.608 101.849 132.972 103 130 103H19C17.3355 103 15.3106 102.492 13.8112 101.256C12.5191 100.191 11 98.0911 11 93.5V46.5Z"
      :fill="color"
    />
    <path
      fill-rule="evenodd"
      clip-rule="evenodd"
      d="M24 62.5C24 59.4624 26.4624 57 29.5 57H70.5C73.5376 57 76 59.4624 76 62.5C76 65.5376 73.5376 68 70.5 68H29.5C26.4624 68 24 65.5376 24 62.5Z"
      :fill="secondaryColor"
    />
    <path
      fill-rule="evenodd"
      clip-rule="evenodd"
      d="M24 85.5C24 82.4624 26.4624 80 29.5 80H50.5C53.5376 80 56 82.4624 56 85.5C56 88.5376 53.5376 91 50.5 91H29.5C26.4624 91 24 88.5376 24 85.5Z"
      :fill="secondaryColor"
    />
  </svg>
</template>
<script>
export default {
  props: {
    color: {
      type: String,
      default: "#E10E1C",
    },
    secondaryColor: {
      type: String,
      default: "#FBBB21",
    },
    size: {
      type: Number,
      default: 24,
    },
  },
};
</script>
